import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_CATALOG_ENTRY_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, GetLoginCredentialDb, getModValue, linksUrl } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/catalogEntrySlice"

const CatalogEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { token, user } = useSelector((state) => state.auth)
  const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")
  let [selBillType, setSelBillType] = useState("")
  let [entryLabel, setEntryLabel] = useState("")
  const { itype } = useParams()
  console.log(itype)

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)
    disapatch(resetDetailParams())
  }, [])

  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.catalogEntry.fetch,
    queryKey: "Catalog Item List",

  })
  const funFilterData = (billType) => {
    filterData({
      data: {
        compcode: compCode.join(","),
        billtype: billType,
        action:null,
        fromdate:null,
        todate:null
      }
    })

  }

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "Chal_No",
    "Lac_Desc",
    "Pac_Desc",
    "Pcs",
    "Chal_Date",
    "PersonName"

  ]
  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)


  useEffect(() => {

    const params = [ENUM_CATALOG_ENTRY_TYPE.Inward, ENUM_CATALOG_ENTRY_TYPE.Outward]
    if (!params.includes(String(itype)))
      navigate(linksUrl.dashboard.tradingDashboard)

    if (itype && itype != "") {
      let t_billType = ""
      if (itype == ENUM_CATALOG_ENTRY_TYPE.Inward) {
        t_billType = "I"
        setEntryLabel("Inward")
        setInitialColumn(["actions",
          "Chal_No",
          "Lac_Desc",
          "Pac_Desc",
          "Pcs",
          "Chal_Date"])
      }
      if (itype == ENUM_CATALOG_ENTRY_TYPE.Outward) {
        t_billType = "O"
        setEntryLabel("Outward")
        setInitialColumn(INITIAL_VISIBLE_COLUMNS)
      }
      setSelBillType(t_billType)
      funFilterData(t_billType)

    }


  }, [itype])

  const onSuccessDelete = (data) => {
    setItemToDelete("")

    if (data && data.length > 0) {
      if (data[0].ref == 1) {
        toast.error("Entry can't be delete  ", {
          "position": "top-center",
          "className": "toast-error",
        })
      }
      else {
        toast.success("deleted successfully", {
          position: "top-center"
        })
        funFilterData(selBillType);
      }

    }
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.catalogEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalPcs = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Pcs",
      }),
    [data]
  )


  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Chal No",
      uid: "Chal_No",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,

    },
    {
      name: "From Loc.",
      uid: "Lac_Desc",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,

    },
    {
      name: "To Loc.",
      uid: "Pac_Desc",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,

    },
    {
      name: "Pcs",
      uid: "Pcs",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.left,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalPcs,
      },
    },
    {
      name: "Date",
      uid: "Chal_Date",
      sortable: true,
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,

    },
    {
      name: "Person",
      uid: "PersonName",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,

    },

  ]
  const exportColumns = [

    {
      name: "Chal No",
      uid: "Chal_No",
    },

    {
      name: "From Loc.",
      uid: "Lac_Desc",
    },
    {
      name: "To Loc.",
      uid: "Pac_Desc",
    },
    {
      name: "Pcs",
      uid: "Pcs",
    },
    {
      name: "Date",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date
    },
    {
      name: "Person",
      uid: "PersonName",
    },

  ]

  let downloadDataFooter = {
    Chal_No: "",
    Chal_Date: "",
    Pcs: " Total:" + totalPcs,


  }

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const handleConfirmBox = (data) => {
    if (data) {

      FndeleteNote({
        data: {
          comp_code: itemToDelete.comp_code,
          bill_type: itemToDelete.bill_type,
          trans_id: itemToDelete.transactionid

        }
      })
    }
    else {
      setItemToDelete("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        const obj = { comp_code: row.CompCode, bill_type: row.Bill_Type, transactionid: row.TransactionId }
        disapatch(setDetailParams(obj))
        disapatch(setNewEntryMode(false))
        navigate(getRedirectUrl())
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        const obj = { comp_code: row.CompCode, bill_type: row.Bill_Type, transactionid: row.TransactionId }
        setItemToDelete(obj)
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]
  const getRedirectUrl = () => {
    if (itype == ENUM_CATALOG_ENTRY_TYPE.Inward)
      return linksUrl.catalogEntry.inward.createCatalogEntry + "/" + itype
    else if (itype == ENUM_CATALOG_ENTRY_TYPE.Outward)
      return linksUrl.catalogEntry.outward.createCatalogEntry + "/" + itype
    else
      return ""
  }
  const handleAddNew = () => {
    disapatch(resetDetailParams())
    navigate(getRedirectUrl())
  }



  return (
    <div>

      {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}

      <MainContainer
        pageName={`Catalog ${entryLabel} Entry`}
        info={[]}
        breadcrumbs={["Product Catalog", `Catalog ${entryLabel} Entry`]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={initialColumn}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          showAdvanceFilter={false}
          downloadFileName="Catalog-List"
          id="TransactionId"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default CatalogEntryMaster
